module.exports = __webpack_public_path__ + "media/images/logo-mini-1ebd473bdef0a17860f0d0cedae1dff5.svg";